/**
 * Replaces all non-alpha-numeric characters with an underscore
 */
export function getSafeString(str: string): string {
  return `${str}`.trim().replace(/[^a-zA-Z0-9]/g, '_');
}
